(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pouchify-intro"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pouchify-intro')) {
    customElements.define('pouchify-intro', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.dialog = this.querySelector('dialog');
        this.key = 'pouchify:intro:seen:v1';
        this.editor = this.dataset.editor === 'true';
        this.duration = Math.min(5000, Math.max(3000, Number(this.dataset.duration) || 4000));
        this.dialog.style.setProperty('--pi-duration', this.duration + 'ms');
        this.querySelector('[data-close]').addEventListener('click', () => this.dismiss());
        this.dialog.addEventListener('close', () => clearTimeout(this.timer));
        this.querySelector('[data-preview]')?.addEventListener('click', () => this.play(true));
        this.onPageHide = () => this.dismiss();
        window.addEventListener('pagehide', this.onPageHide);
        if (!this.editor) this.play(false);
      }
      async play(preview) {
        if (this.busy || this.dialog.open || typeof this.dialog.showModal !== 'function') return;
        if (!preview) {
          if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          try { if (localStorage.getItem(this.key)) return; } catch (_) { return; }
          if (document.querySelector('dialog[open], [aria-modal="true"]')) return;
        }
        const images = [...this.querySelectorAll('img[data-src]')];
        if (!images.length && !preview) return;
        this.busy = true;
        let interacted = false;
        const noteInteraction = () => { interacted = true; };
        document.addEventListener('pointerdown', noteInteraction, { once: true });
        document.addEventListener('keydown', noteInteraction, { once: true });
        const ready = Promise.all(images.map(img => {
          img.src = img.dataset.src;
          return img.decode().catch(() => {});
        }));
        await Promise.race([ready, new Promise(resolve => setTimeout(resolve, 700))]);
        document.removeEventListener('pointerdown', noteInteraction);
        document.removeEventListener('keydown', noteInteraction);
        this.busy = false;
        if (!this.isConnected || (!preview && (interacted || document.hidden || document.querySelector('dialog[open], [aria-modal="true"]')))) return;
        for (const img of images) img.hidden = !img.complete || !img.naturalWidth;
        if (!preview && images.every(img => img.hidden)) return;
        if (!preview) {
          try {
            if (localStorage.getItem(this.key)) return;
            localStorage.setItem(this.key, '1');
          } catch (_) { return; }
        }
        this.dialog.showModal();
        this.timer = setTimeout(() => this.dismiss(), this.duration);
      }
      dismiss() { clearTimeout(this.timer); if (this.dialog?.open) this.dialog.close(); }
      disconnectedCallback() { this.dismiss(); window.removeEventListener('pagehide', this.onPageHide); this.bound = false; }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
